import { AutogenLayoutUserQuickInfo } from "./autogen/AutogenLayoutUserQuickInfo";

export class UserQuickInfo extends AutogenLayoutUserQuickInfo {
}
